// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3WcED","avatar":"style_avatar__DuH_0","menuIcon":"style_menuIcon__208Lj"};